module.exports = __webpack_public_path__ + "img/sign-in.ec476295.png";